import { AboutMeContent } from "./styles";

function AboutMe() {
  return (
    <AboutMeContent name="about">
      <h1><span>{">"}</span> Sobre Mim</h1>
      <div className="content">
          <div className="divText">
            <span>{">"}</span> Sou apaixonado por transformar códigos em aplicações que trazem impacto
            positivo na vida das pessoas. 
          </div><br></br>
          <div>
          <span>{">"}</span> Meu primeiro contato com programação aconteceu aos 15 anos quando ganhei o meu primeiro computador. Um amigo que na época estudava programação me apresentou os primeiros códigos.
          
          Sem dúvidas esse ponto fez a diferença para a minha escolha de curso
            técnico em 2010. Lá eu descobri de fato como era desenvolver
            algo do zero. Tive contato com HTML, CSS, JavaScript, C, C++ e
            principalmente Python. No projeto final desenvolvi em dupla um código em
            C++ para controlar via JoyStick um robô que utilizava um Arduino.
          </div> <br></br>
          <div>
          <span>{">"}</span> Entretanto, a vida me levou para outro caminho profissional. Incentivado
            por colegas de empresa eu decidi seguir a na área de
            redes/infraestrutura tendo atuado por 10 anos nessa área. Em 2014 me
            certifiquei CCNA, após meses de muito estudo e dedicação, vindo a fazer
            a renovação em 2019.
          </div> <br></br>
          <div>
          <span>{">"}</span> No início de 2020, impulsionado pela pandemia e também por transições
            que estavam acontecendo na empresa que atuava, decidi empreender em
            outra área e firmei uma parceria com uma amiga que é fotógrafa. Abrimos
            uma agência de marketing digital ao qual atuamos por 1 ano e meio em
            projetos de várias áreas diferentes.
          </div> <br></br>
          <div>
          <span>{">"}</span> No final de 2021 encerramos o projeto e eu decidi voltar os meus
            esforços para aquilo que eu sempre gostei: programação. Atualmente,
            estudo desenvolvimento web full stack na Kenzie Academy Brasil tendo já
            concluído todo o módulo de Front-end.
          </div> <br></br>
          <div>
          <span>{">"}</span> Me considero uma pessoa curiosa, que gosta de trabalhar em equipe e
            ajudar o próximo, com uma boa comunicação, empatia e com forte senso de
            coletividade. Minhas experiências de trabalho anteriores trouxeram uma
            boa visão de como uma empresa funciona por dentro, como é a colaboração
            e como é trabalhar em ambientes críticos e em momentos de pressão.
          </div> <br></br>
          <div>
          <span>{">"}</span> Meu objetivo é, através da tecnologia, trazer soluções criativas e
            inovadores que vão facilitar a vida das pessoas!
          </div>
      </div>
    </AboutMeContent>
  );
}

export default AboutMe;
